import { Http } from "../../../support";

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
  isValid: false
};

const setData = (store, data) => {
  store.setState((state) => {
    state.cuenta.sucursal.info.data = { ...data };
  });
}

const get = async (store, id, params = {}) => {
  store.setState((state) => {
    state.cuenta.sucursal.info.busy = true;
  });

  try {
    const response = await Http.get(`api/catalogos/sucursal/${id}`, { params });

    store.setState((state) => {
      state.cuenta.sucursal.info.data = response.data;
      state.cuenta.sucursal.info.busy = false;
    });

    return response.data;
  } catch (error) {
    store.setState((state) => {
      state.cuenta.sucursal.info.error = error.data || error;
      state.cuenta.sucursal.info.busy = false;
    });
  }
}

const resetError = (store) => state => {
  state.cuenta.sucursal.info.error = undefined;
};

const reset = (store) => state => {
  state.cuenta.sucursal.info = { ...initialState };
};

const actions = {
  setData,
  get,
  reset,
  resetError
}

const SucursalInfoStore = {
  state: () => initialState,
  actions
}

export default SucursalInfoStore;